import React, {useEffect} from 'react';
import {ErrorBoundary} from 'react-error-boundary';
import {Navigate, Outlet} from 'react-router-dom';

import {getLoginToken} from 'infra/http/utils';
import {ErrorFallback} from 'presentation/components';
import {SelectionFlowEnum, SignInEnum} from 'presentation/constants';
import {useSelectedPlanStore} from 'presentation/pages/others/selection-flow/store/useSelectedPlanStore';
import {useExternalServiceStore} from 'presentation/pages/private/store/externalSerivceUrlStore';
import {translations} from 'presentation/translations-new';

const {perksClub, emergencyTelehealth, recommendation} = translations['pt-br'].privateFlow.services;

export const PlanRoute = () => {
	const loginToken = getLoginToken();
	const resetUrl = useExternalServiceStore(state => state.resetUrl);

	useEffect(() => {
		resetUrl(perksClub);
		resetUrl(recommendation);
		resetUrl(emergencyTelehealth);
	}, []);

	if (!loginToken) {
		return <Navigate to={SignInEnum.SIGN_IN} state={{goToSignInState: true}} replace />;
	}

	return <Outlet />;
};

export const BeneficiariesRoute = () => {
	const loginToken = getLoginToken();
	const selectedPlan = useSelectedPlanStore(state => state.selectedPlan);

	if (!loginToken) {
		return <Navigate to={SignInEnum.SIGN_IN} state={{goToSignInState: true}} replace />;
	}

	if (!selectedPlan) {
		return <Navigate to={SelectionFlowEnum.PLAN_SELECTION} replace />;
	}

	return (
		<ErrorBoundary
			FallbackComponent={({resetErrorBoundary}) => (
				<ErrorFallback resetErrorBoundary={resetErrorBoundary} />
			)}
			onReset={() => window.location.reload()}>
			<Outlet />
		</ErrorBoundary>
	);
};
